var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3223_61152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3223_61152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.25C6.5375 14.25 6.3595 14.178 6.216 14.034C6.072 13.8905 6 13.7125 6 13.5V12H4.5C4.2875 12 4.10925 11.928 3.96525 11.784C3.82175 11.6405 3.75 11.4625 3.75 11.25C3.75 11.0375 3.82175 10.8592 3.96525 10.7152C4.10925 10.5717 4.2875 10.5 4.5 10.5H6.75C6.9625 10.5 7.14075 10.5717 7.28475 10.7152C7.42825 10.8592 7.5 11.0375 7.5 11.25V13.5C7.5 13.7125 7.42825 13.8905 7.28475 14.034C7.14075 14.178 6.9625 14.25 6.75 14.25ZM4.5 7.5C4.2875 7.5 4.10925 7.428 3.96525 7.284C3.82175 7.1405 3.75 6.9625 3.75 6.75C3.75 6.5375 3.82175 6.35925 3.96525 6.21525C4.10925 6.07175 4.2875 6 4.5 6H6V4.5C6 4.2875 6.072 4.10925 6.216 3.96525C6.3595 3.82175 6.5375 3.75 6.75 3.75C6.9625 3.75 7.14075 3.82175 7.28475 3.96525C7.42825 4.10925 7.5 4.2875 7.5 4.5V6.75C7.5 6.9625 7.42825 7.1405 7.28475 7.284C7.14075 7.428 6.9625 7.5 6.75 7.5H4.5ZM11.25 14.25C11.0375 14.25 10.8595 14.178 10.716 14.034C10.572 13.8905 10.5 13.7125 10.5 13.5V11.25C10.5 11.0375 10.572 10.8592 10.716 10.7152C10.8595 10.5717 11.0375 10.5 11.25 10.5H13.5C13.7125 10.5 13.8905 10.5717 14.034 10.7152C14.178 10.8592 14.25 11.0375 14.25 11.25C14.25 11.4625 14.178 11.6405 14.034 11.784C13.8905 11.928 13.7125 12 13.5 12H12V13.5C12 13.7125 11.9283 13.8905 11.7848 14.034C11.6408 14.178 11.4625 14.25 11.25 14.25ZM11.25 7.5C11.0375 7.5 10.8595 7.428 10.716 7.284C10.572 7.1405 10.5 6.9625 10.5 6.75V4.5C10.5 4.2875 10.572 4.10925 10.716 3.96525C10.8595 3.82175 11.0375 3.75 11.25 3.75C11.4625 3.75 11.6408 3.82175 11.7848 3.96525C11.9283 4.10925 12 4.2875 12 4.5V6H13.5C13.7125 6 13.8905 6.07175 14.034 6.21525C14.178 6.35925 14.25 6.5375 14.25 6.75C14.25 6.9625 14.178 7.1405 14.034 7.284C13.8905 7.428 13.7125 7.5 13.5 7.5H11.25Z",
    fill: "black",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/Standard.32225b22.svg";
export { ForwardRef as ReactComponent };